class GlobalTracking {

	constructor($target) {
		
		//Private properties
        $target;
		let name = "HELLO";
	
		function init(){
			bindSocialEvents();
			bindLinkEvents();
			bindDonateEvents();
			bindContactEvents();
			bindNewsletterEvents();
			bindMentoringEvents();
			bindVolenteerPageEvents();
		}

		function bindVolenteerPageEvents(){

			let eventType = "Volunteer";

			if($target.hasClass('volunteer-with-us')){
				$target.find('.block_page_hero_with_link__btn_container').each(function(){

					$(this).bind("click",{
						type:eventType,
						location: "Contact",
						name:"Volunteer"
						}, onLinkClick)

				})
			}
			
		}

		function bindMentoringEvents(){

			let eventType = "Mentoring"

			if($target.hasClass('online-mentoring-for-16-18-year-olds'))
			{
				$('[data-jst-track-category]').each(function(){
					
					$(this).bind("click",{
						type:eventType,
						location: $(this).data("jst-track-category"),
						name:"Contact"
						}, onLinkClick)

				})
			}

		}

		function bindNewsletterEvents(){

			let eventType = "Newsletter";

			$target.find('.footer__form__button').each(function(){
				$(this).bind("click",{
					type:eventType,
					location: "Footer",
					name:"Subscribe"
					}, onLinkClick)
			})
		}

		function bindContactEvents(){

			let eventType = "Contact"

			$target.find('.block_contact').each(function(){
				$(this).find('.wpcf7-submit').each(function(){
					$(this).bind("click",{
						type:eventType,
						location: "Form",
						name:"Submit"
					  }, onLinkClick)
				})
			})
		}

		function bindDonateEvents(){

			let eventType = "Donate"

			$target.find('.header').each(function(){
				$(this).find('.donate_button').each(function(){
					$(this).bind("click",{
						type:eventType,
						location: "Header",
						name:eventType
					  }, onLinkClick)
				})
			})

			$target.find('.footer').each(function(){
				$(this).find('.donate_button').each(function(){
					$(this).bind("click",{
						type:eventType,
						location: "Footer",
						name:eventType
					  }, onLinkClick)
				})
			})
		
			$target.find('.blog-post').each(function(){
				$(this).find("a[href*='uk.virginmoneygiving.com']").each(function(){
					$(this).bind("click",{
						type:eventType,
						location: "In-page",
						name:eventType
					  }, onLinkClick)
				})
			})
			
		}

		function bindLinkEvents(){

			let eventType = "RTS"
			
			if($target.hasClass('rts-young-talent-of-the-year-award'))
			{
				console.log("RTS PAGE")
				$("a[href*='rts.org.uk']").each(function(){
					$(this).bind("click",{
						type:eventType,
						location: "External",
						name:"RTS Website"
					  }, onLinkClick)
				})
			}
			
		}
		function onLinkClick(event){
			trackEvent(
				{
					type : event.data.type, 
					eventData:{
						'event_category' : event.data.location,
						'event_label' : event.data.name
					}
				}
			)
		}
		function bindSocialEvents(){
			
			let eventType = "Social"

			$target.find('.block_contact').each(function(){
				$(this).find('.social_icons_link').each(function(){
					$(this).bind("click",{
						type:eventType,
						location: "Contact Page"
					  }, onSocialClick)
				})
			})
			
			$target.find('.footer__content_container').each(function(){
				$(this).find('.social_icons_link').each(function(){
					$(this).bind("click",{
						type:eventType,
						location: "Footer"
					  }, onSocialClick)
				})
			})

			$target.find('.block_latest_news').each(function(){
				$(this).find('.social_icons_link').each(function(){
					$(this).bind("click",{
						type:eventType,
						location: "News Hub"
					}, onSocialClick)
				})
			})

		}

		init();

		function onSocialClick(event){

			let classNames = $(event.currentTarget).find('i')[0].classList.value;
			let indexOfClassname = classNames.indexOf('fa-');
			let iconClassName = classNames.substring(indexOfClassname);
			let socialName = iconClassName.split('-')[1];
			let socialTrackName = socialName.charAt(0).toUpperCase() + socialName.slice(1);

			trackEvent(
				{
					type : event.data.type, 
					eventData:{
						'event_category' : event.data.location,
						'event_label' : socialTrackName
					}
				}
			)
			
		}

		function trackEvent (trackingObject){
			gtag('event', trackingObject.type, {
				'event_category' : trackingObject.eventData.event_category,
				'event_label' : trackingObject.eventData.event_label
			  });
		}

		return {

			name:name,

			trackEvent:trackEvent

		}

	}

}

export default GlobalTracking;